import requestInstance from './Request';
import { setCurrentUser } from '../utils/utils';
import { API_ENDPOINT } from './Api';

let env = process.env.REACT_APP_API_BASE_URL;
const businessType = localStorage?.getItem('businessType');

export const rideDetailsApi = async (data) => {
  const url = `${env}${
    API_ENDPOINT.Dashboard.rideDetailsApi +
    '?dateFrom=' +
    data?.dateFrom +
    '&dateTo=' +
    data?.dateTo
  }&${businessType}=true`;

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const totalRegistrationApi = async (data) => {
  const url = `${env}${
    API_ENDPOINT.Dashboard.registrationApi +
    '?dateFrom=' +
    data?.dateFrom +
    '&dateTo=' +
    data?.dateTo
  }&${businessType}=true`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const rideAnalyticApi = async (data) => {
  const url = `${env}${
    API_ENDPOINT.Dashboard.rideAnalyticApi +
    '?dateFrom=' +
    data?.dateFrom +
    '&dateTo=' +
    data?.dateTo +
    '&type=' +
    (data?.type ? data?.type : '')
  }&${businessType}=true`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const dailyCustomerApi = async (data) => {
  const url = `${env}${
    API_ENDPOINT.Dashboard.ourCustomerApi +
    '?location=' +
    (data?.location ? data?.location : '') +
    '&dateFrom=' +
    data?.dateFrom +
    '&dateTo=' +
    data?.dateTo
  }`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
